import { ListResponse } from "../../model/common/ListResponse";
import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";

const MEMO_URL = `/repair-shop/order-memos`;

/**
 * 고객센터 메모 조회 API
 * @param id
 * @returns
 */
export const fetchOrderMemo = async (id: number) => {
  const url = `${MEMO_URL}/${id}`;
  const response = await httpRequest({ method: axiosUtils.GET, url });
  return response?.data.row;
};

/**
 * 주문번호별 고객센터 메모
 * @param orderNo
 * @returns
 */
export const getOrderMemoByOrderNo = async (
  orderNo: string
): Promise<ListResponse<any>> => {
  const url = `${MEMO_URL}/orders/${orderNo}`;

  const response = await httpRequest({ method: axiosUtils.GET, url });

  return response?.data;
};
